import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { FacilityDTO, FacilityFloorDTO } from "../facilities/Facility";

const PATH = "facilities";

@Injectable({
  providedIn: "root",
})
export class FacilityHandlerService {
  constructor(private APIService: ApiService) {}

  getFacilities(
    masterAccountID: number,
    queryParams?: {
      page?: number;
      perPage?: number;
    },
  ) {
    return this.APIService.get(`${PATH}/${masterAccountID}`, {
      params: queryParams,
    });
  }

  getFacility(masterAccountID: number, facilityID: number) {
    return this.APIService.get(`${PATH}/${masterAccountID}/${facilityID}`);
  }

  deleteFacility(masterAccountID: number, facilityID: number) {
    return this.APIService.delete(`${PATH}/${masterAccountID}/${facilityID}`);
  }

  postFacility(masterAccountID: number, facilityDTO: FacilityDTO) {
    return this.APIService.post(`${PATH}/${masterAccountID}`, facilityDTO);
  }

  putFacility(masterAccountID: number, facilityDTO: FacilityDTO) {
    return this.APIService.put(
      `${PATH}/${masterAccountID}/${facilityDTO.id}`,
      facilityDTO,
    );
  }

  postFloor(masterAccountID: number, facilityFloorDTO: FacilityFloorDTO) {
    return this.APIService.post(
      `facility_floors/${masterAccountID}`,
      facilityFloorDTO,
    );
  }

  putFloor(masterAccountID: number, facilityFloorDTO: FacilityFloorDTO) {
    return this.APIService.put(
      `facility_floors/${masterAccountID}/${facilityFloorDTO.id}`,
      facilityFloorDTO,
    );
  }

  deleteFloor(masterAccountID: number, facilityFloorDTO: FacilityFloorDTO) {
    return this.APIService.delete(
      `facility_floors/${masterAccountID}/${facilityFloorDTO.id}`,
    );
  }
}
